import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/mm/Brand";

export default function AuthCallback() {
  const done = useRef(false);
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [err, setErr] = useState("");
  const [challenge, setChallenge] = useState("");
  const [code, setCode] = useState("");
  const remember = sessionStorage.getItem("bp_google_remember") === "1";
  const ageConfirmed = sessionStorage.getItem("bp_google_age") === "1";

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", { session_id: sid, remember_me: remember, age_18_confirmed: ageConfirmed }, { timeout: 90000, silentFeedback: true })
      .then(async ({ data }) => { if(data.mfa_required) setChallenge(data.challenge_token); else { sessionStorage.removeItem("bp_google_remember");sessionStorage.removeItem("bp_google_age"); await signIn(data.token, data.user, remember); nav("/app", { replace: true }); } })
      .catch((e) => setErr(e?.code === "ECONNABORTED" ? "The server took too long to respond. Please try signing in again; the staging server may have been asleep." : errMsg(e)));
  }, [nav, signIn, remember, ageConfirmed]);

  const verify = async (event) => {
    event.preventDefault();setErr("");
    try { const {data}=await api.post("/auth/mfa/verify-login",{challenge_token:challenge,code,remember_me:remember});sessionStorage.removeItem("bp_google_remember");sessionStorage.removeItem("bp_google_age");await signIn(data.token,data.user,remember);nav("/app",{replace:true}); }
    catch(e){setErr(errMsg(e));}
  };

  return (
    <div className="grid min-h-screen place-items-center p-6" data-testid="auth-callback">
      {challenge ? <form className="mm-card w-full max-w-sm space-y-4 text-center" onSubmit={verify}><h1 className="text-xl font-bold">Verify it’s you</h1><p className="text-sm text-[var(--mu)]">Enter your authenticator or recovery code.</p><input className="mm-input num text-center" autoComplete="one-time-code" value={code} onChange={(e)=>setCode(e.target.value)} required />{err&&<p className="text-sm text-[var(--dg)]">{err}</p>}<button className="mm-btn w-full justify-center">Verify & sign in</button></form> : err ? (
        <div className="mm-card max-w-sm text-center">
          <p className="mb-4">{err}</p>
          <button className="mm-btn" onClick={() => nav("/", { replace: true })} data-testid="auth-callback-back-button">Back to sign in</button>
        </div>
      ) : <BrandMark className="h-16 w-16 animate-pulse" />}
    </div>
  );
}
